import React, { useContext } from 'react';

import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import { ConfigProvider, message } from 'antd';

import 'antd/dist/reset.css';

import './App.css';

import './styles/theme.css';



// Context

import { AuthProvider, AuthContext } from './contexts/AuthContext';

import { ThemeProvider, useTheme } from './contexts/ThemeContext';



// Layouts

import DashboardLayout from './components/layouts/DashboardLayout';

import AuthLayout from './components/layouts/AuthLayout';



// Pages - Auth

import LandingPage from './pages/Landing/LandingPage';

import Login from './pages/Auth/Login';

import Signup from './pages/Auth/Signup';

import ForgotPassword from './pages/Auth/ForgotPassword';

import ResetPassword from './pages/Auth/ResetPassword';

import OAuthCallback from './pages/OAuthCallback';



// Pages - Legal

import PrivacyPolicy from './pages/Legal/PrivacyPolicy';

import TermsOfService from './pages/Legal/TermsOfService';



// Pages - Dashboard

import SuperAdminDashboard from './components/dashboard/SuperAdminDashboard';

import ClientDashboard from './components/dashboard/ClientDashboard';



// Components

import ProtectedRoute from './components/common/ProtectedRoute';

import Logout from './components/common/Logout';

// Pages - SuperAdmin

import AllAgenciesList from './pages/SuperAdmin/Agencies/AllAgenciesList';

import AgencyRegistrations from './pages/SuperAdmin/Agencies/AgencyRegistrations';

import AgencyDetails from './pages/SuperAdmin/Agencies/AgencyDetails';

import AgencyActions from './pages/SuperAdmin/Agencies/AgencyActions';

import WhiteLabelAgenciesList from './pages/SuperAdmin/Agencies/WhiteLabelAgenciesList';

import WhiteLabelAgencyDetails from './pages/SuperAdmin/Agencies/WhiteLabelAgencyDetails';

import AllClientsList from './pages/SuperAdmin/Clients/AllClientsList';

import ClientDetails from './pages/SuperAdmin/Clients/ClientDetails';

import AssignTransferClients from './pages/SuperAdmin/Clients/AssignTransferClients';

import WorkspacesOverview from './pages/SuperAdmin/Workspaces/WorkspacesOverview';

import Estimates from './pages/SuperAdmin/Estimates';

import CreateCampaign from './pages/SuperAdmin/CreateCampaign';

import DatabaseManagement from './pages/SuperAdmin/DatabaseManagement';

import BillingSubscriptions from './pages/SuperAdmin/BillingSubscriptions';

import SecurityCompliance from './pages/SuperAdmin/SecurityCompliance';

import UserManagement from './pages/SuperAdmin/UserManagement';

import IntegrationsControl from './pages/SuperAdmin/IntegrationsControl';

import PlatformSettings from './pages/SuperAdmin/PlatformSettings';

import AnalyticsReports from './pages/SuperAdmin/AnalyticsReports';

import AllCampaignsList from './pages/SuperAdmin/Campaigns/AllCampaignsList';

import CampaignApprovals from './pages/SuperAdmin/Campaigns/CampaignApprovals';

import CampaignsFlagged from './pages/SuperAdmin/Campaigns/CampaignsFlagged';

import AgencyPlans from './pages/SuperAdmin/Billing/AgencyPlans';

import ClientPlans from './pages/SuperAdmin/Billing/ClientPlans';

import InvoicesPayments from './pages/SuperAdmin/Billing/InvoicesPayments';

import PaymentGateways from './pages/SuperAdmin/Billing/PaymentGateways';

import FacebookSettings from './pages/SuperAdmin/Integrations/FacebookSettings';

import GoogleAdsSettings from './pages/SuperAdmin/Integrations/GoogleAdsSettings';

import OtherPlatforms from './pages/SuperAdmin/Integrations/OtherPlatforms';

import BrandingWhiteLabel from './pages/SuperAdmin/Settings/BrandingWhiteLabel';

import EmailTemplates from './pages/SuperAdmin/Settings/EmailTemplates';

import RolesPermissions from './pages/SuperAdmin/Settings/RolesPermissions';

import AdminsList from './pages/SuperAdmin/Users/AdminsList';

import UsersRoles from './pages/SuperAdmin/Users/UsersRoles';

import RevenueReports from './pages/SuperAdmin/Analytics/RevenueReports';

import CampaignPerformance from './pages/SuperAdmin/Analytics/CampaignPerformance';

import GrowthMetrics from './pages/SuperAdmin/Analytics/GrowthMetrics';

import AuditLogs from './pages/SuperAdmin/System/AuditLogs';

import SystemNotifications from './pages/SuperAdmin/SystemNotifications';

import DemoRequests from './pages/Admin/DemoRequests';

import SupportRequests from './pages/SuperAdmin/Support/SupportRequests';

import AssignTickets from './pages/SuperAdmin/Support/AssignTickets';

import GDPRPrivacy from './pages/SuperAdmin/Security/GDPRPrivacy';

import TwoFactorAuth from './pages/SuperAdmin/Security/TwoFactorAuth';

import APIKeysManagement from './pages/SuperAdmin/Security/APIKeysManagement';

import AudienceLab from './pages/SuperAdmin/Audience/AudienceLab';

import SubscribersManagement from './pages/SuperAdmin/SubscribersManagement';

import ClientAllCampaigns from './pages/Client/Campaigns/AllCampaigns';

import ClientCreateCampaign from './pages/Client/Campaigns/CreateCampaign';

import ClientDraftsScheduled from './pages/Client/Campaigns/DraftsScheduled';

import ClientRouteBasedDemo from './pages/Client/Campaigns/RouteBasedDemo.js';

import ClientNewCampDemo from './pages/Client/Campaigns/NewCampDemo';

import ClientNewCampaignUX from './pages/Client/Campaigns/NewCampaignUX';

import ClientEditCampaign from './pages/Client/Campaigns/EditCampaign';

import ClientVehicleHistory from './pages/Client/History/VehicleHistory';

import ClientProximityMarketing from './pages/Client/CRM/ProximityMarketing';

import ClientMediaLibrary from './pages/Client/Creatives/MediaLibrary';

import ClientTemplatesPresets from './pages/Client/Creatives/TemplatesPresets';

import ClientTextAssets from './pages/Client/Creatives/TextAssets';

import ClientSavedAudiences from './pages/Client/Audience/SavedAudiences';

import ClientLookalikeAudiences from './pages/Client/Audience/LookalikeAudiences';

import ClientCustomAudienceBuilder from './pages/Client/Audience/CustomAudienceBuilder';

import ClientBudgetPlanner from './pages/Client/Budgets/BudgetPlanner';

import ClientSchedulingCalendar from './pages/Client/Budgets/SchedulingCalendar';

import ClientAnalyticsPerformance from './pages/Client/Analytics/Performance';

import ClientAnalyticsConversions from './pages/Client/Analytics/Conversions';

import ClientAnalyticsROIReports from './pages/Client/Analytics/ROIReports';

import ClientNeighborhoodLens from './pages/Client/NeighborhoodLens/NeighborhoodLens';

import DatasetPayment from './pages/Client/Payment/DatasetPayment';

import ClientIntegrations from './pages/Client/Integrations/Integrations';

import ClientFacebookManager from './pages/Client/Integrations/FacebookManager';

import ClientGoogleAds from './pages/Client/Integrations/GoogleAds';

import ClientOtherPlatforms from './pages/Client/Integrations/OtherPlatforms';

import ClientAdCreatives from './pages/Client/AdCreatives/AdCreatives';

import ClientAudienceTargeting from './pages/Client/Audience/AudienceTargeting';

import ClientBudgetsScheduling from './pages/Client/Budgets/BudgetsScheduling';

import ClientAnalyticsReports from './pages/Client/Analytics/AnalyticsReports';

import ClientBillingPlans from './pages/Client/Billing/BillingPlans';

import ClientCurrentSubscription from './pages/Client/Billing/CurrentSubscription';

import ClientPaymentHistory from './pages/Client/Billing/PaymentHistory';

import ClientUpgradePlan from './pages/Client/Billing/UpgradePlan';

import ClientNotifications from './pages/Client/Notifications';

import ClientSupportCenter from './pages/Client/Support/SupportCenter';

import ClientSettings from './pages/Client/Settings/Settings';

import ClientProfileSettings from './pages/Client/Settings/ProfileSettings';

import ClientSecurityLogin from './pages/Client/Settings/SecurityLogin';

import ClientGeoTabSettings from './pages/Client/Settings/GeoTabSettings';

import ClientAddinsConfiguration from './pages/Client/Addins/AddinsConfiguration';

import ClientAddinLatestInsertKeyReport from './pages/Client/Addins/LatestInsertKeyReport';

import ClientAddinMapReplay from './pages/Client/Addins/MapReplay';

import ClientAddinSurveillanceCameras from './pages/Client/Addins/SurveillanceCameras';

import ClientAddinsConfigration from './pages/Client/Addins/AddinsConfigration';

import ClientVehicleManagement from './pages/Client/Vehicles/VehicleManagement';

import McpMap from './pages/Client/MCP/McpMap';

import McpFleet from './pages/Client/MCP/McpFleet';

import McpAudiences from './pages/Client/MCP/McpAudiences';

import McpAutomations from './pages/Client/MCP/McpAutomations';

import McpAutomationFlow from './pages/Client/MCP/McpAutomationFlow';

import McpConnections from './pages/Client/MCP/McpConnections';

import McpSettings from './pages/Client/MCP/McpSettings';

import McpBilling from './pages/Client/MCP/McpBilling';

import McpCampaign from './pages/Client/MCP/McpCampaign';
import McpBuild from './pages/Client/MCP/McpBuild';

import AdminVehicleManagement from './pages/Agency/Vehicles/AdminVehicleManagement';



// Pages - Agency (Portal) - Consolidated with Tabs

import AgencyPortalDashboard from './pages/Agency/Dashboard/Dashboard';

import AgencyWorkspaces from './pages/Agency/Workspaces/Workspaces';

import AgencyClients from './pages/Agency/Clients/Clients';

import AgencyCampaigns from './pages/Agency/Campaigns/Campaigns';

import AgencyNewCampaign from './pages/Agency/NewCampaign/NewCampaign';

import AgencyCreatives from './pages/Agency/Creatives/Creatives';

import AgencyAudience from './pages/Agency/Audience/Audience';

import AgencyBudgets from './pages/Agency/Budgets/Budgets';

import AgencyAnalytics from './pages/Agency/Analytics/Analytics';

import AgencyTeam from './pages/Agency/Team/Team';

import AgencyIntegrations from './pages/Agency/Integrations/Integrations';

import AgencyBilling from './pages/Agency/Billing/Billing';

import AgencySettings from './pages/Agency/Settings/Settings';

import AgencyNotifications from './pages/Agency/Notifications/Notifications';

import AgencySupport from './pages/Agency/Support/Support';

import AgencyChat from './pages/Agency/Chat/Chat';

import AgencyAITools from './pages/Agency/AITools/AITools';

import NeighborhoodLens from './pages/Agency/NeighborhoodLens/NeighborhoodLens';



// Pages - WhiteLabel Agency

import WhiteLabelDashboard from './pages/WhiteLabelAgency/Dashboard/Dashboard';

import WhiteLabelCampaigns from './pages/WhiteLabelAgency/Campaigns/Campaigns';

import WhiteLabelCreateCampaign from './pages/WhiteLabelAgency/Campaigns/CreateCampaign';

import WhiteLabelClients from './pages/WhiteLabelAgency/Clients/Clients';

import WhiteLabelClientDashboard from './pages/WhiteLabelAgency/Clients/ClientDashboard';

import WhiteLabelCommissions from './pages/WhiteLabelAgency/Commissions/Commissions';

import WhiteLabelSettings from './pages/WhiteLabelAgency/Settings/Settings';

import WhiteLabelBilling from './pages/WhiteLabelAgency/Billing/Billing';

import WhiteLabelBranding from './pages/WhiteLabelAgency/Settings/Branding';

import WhiteLabelSupport from './pages/WhiteLabelAgency/Support/Support';

import WhiteLabelAnalytics from './pages/WhiteLabelAgency/Analytics/Analytics';

import WhiteLabelAITools from './pages/WhiteLabelAgency/AITools/AITools';

import WhiteLabelReports from './pages/WhiteLabelAgency/Reports/Reports';

import WhiteLabelLocations from './pages/WhiteLabelAgency/Locations/Locations';

import WhiteLabelIntegrations from './pages/WhiteLabelAgency/Integrations/Integrations';

import WhiteLabelPricing from './pages/WhiteLabelAgency/Settings/Pricing';

import WhiteLabelRoles from './pages/WhiteLabelAgency/Settings/Roles';

import WhiteLabelDomain from './pages/WhiteLabelAgency/Settings/Domain';

import WhiteLabelNeighborhoodLens from './pages/WhiteLabelAgency/Settings/NeighborhoodLens';

import WhiteLabelBusinessProfile from './pages/WhiteLabelAgency/Settings/BusinessProfile';



// Configure message component

export const showMessage = (type, content, duration = 3) => {

  message[type]({ content, duration, style: { marginTop: '50px' } });

};



// Themed ConfigProvider wrapper

const ThemedConfigProvider = ({ children }) => {

  const { antdTheme } = useTheme();

  

  return (

    <ConfigProvider theme={antdTheme}>

      {children}

    </ConfigProvider>

  );

};



// Main App component with routing

const AppContent = () => {

  const { currentUser, loading, isAuthenticated } = useContext(AuthContext);



  if (loading) {

    return (

      <div style={{

        display: 'flex',

        justifyContent: 'center',

        alignItems: 'center',

        height: '100vh',

        width: '100vw',

        backgroundColor: '#f0f2f5'

      }}>

        <div className="loader">Loading...</div>

      </div>

    );

  }



  return (

    <Routes>

      {/* Public Routes */}

      <Route path="/logout" element={<Logout />} />

      <Route path="/api/integrations/google-ads/callback" element={<OAuthCallback />} />

      <Route path="/api/integrations/facebook/callback" element={<OAuthCallback />} />

      <Route path="/api/integrations/meta/callback" element={<OAuthCallback />} />

      

      {/* Legal Pages - Public */}

      <Route path="/privacy" element={<PrivacyPolicy />} />

      <Route path="/terms" element={<TermsOfService />} />

      <Route path="/login" element={

        !isAuthenticated() ? (

          <AuthLayout>

            <Login />

          </AuthLayout>

        ) : !currentUser ? (

          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>

            <div className="loader">Loading...</div>

          </div>

        ) : (

          <Navigate to={

            currentUser.role === 'superadmin' ? '/dashboard/superadmin' :

            currentUser.role === 'agency' ? '/dashboard/agency' :

            currentUser.role === 'client' ? '/dashboard/client' :

            currentUser.role === 'whitelabel_agency' ? '/dashboard/whitelabel' : '/'

          } replace />

        )

      } />



      <Route path="/signup" element={

        !isAuthenticated() ? (

          <AuthLayout>

            <Signup />

          </AuthLayout>

        ) : !currentUser ? (

          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>

            <div className="loader">Loading...</div>

          </div>

        ) : (

          <Navigate to={

            currentUser.role === 'superadmin' ? '/dashboard/superadmin' :

            currentUser.role === 'agency' ? '/dashboard/agency' :

            currentUser.role === 'client' ? '/dashboard/client' :

            currentUser.role === 'whitelabel_agency' ? '/dashboard/whitelabel' : '/'

          } replace />

        )

      } />



      {/* Super Admin: AudienceLab */}

      <Route path="/admin/audience/lab" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <AudienceLab />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      

      <Route path="/forgot-password" element={

        !isAuthenticated() ? (

          <AuthLayout>

            <ForgotPassword />

          </AuthLayout>

        ) : !currentUser ? (

          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>

            <div className="loader">Loading...</div>

          </div>

        ) : (

          <Navigate to={

            currentUser.role === 'superadmin' ? '/dashboard/superadmin' :

            currentUser.role === 'agency' ? '/dashboard/agency' :

            currentUser.role === 'client' ? '/dashboard/client' :

            currentUser.role === 'whitelabel_agency' ? '/dashboard/whitelabel' : '/'

          } replace />

        )

      } />

      

      <Route path="/reset-password/:token" element={

        !isAuthenticated() ? (

          <AuthLayout>

            <ResetPassword />

          </AuthLayout>

        ) : !currentUser ? (

          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>

            <div className="loader">Loading...</div>

          </div>

        ) : (

          <Navigate to={

            currentUser.role === 'superadmin' ? '/dashboard/superadmin' :

            currentUser.role === 'agency' ? '/dashboard/agency' :

            currentUser.role === 'client' ? '/dashboard/client' :

            currentUser.role === 'whitelabel_agency' ? '/dashboard/whitelabel' : '/'

          } replace />

        )

      } />



      {/* Protected Dashboard Routes */}

      <Route path="/dashboard/superadmin" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <SuperAdminDashboard />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      <Route path="/dashboard/agency" element={

        <ProtectedRoute roles={['agency']}>

          <DashboardLayout>

            <AgencyPortalDashboard />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      <Route path="/dashboard/client" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientDashboard />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* WhiteLabel Agency: Dashboard */}

      <Route path="/dashboard/whitelabel" element={

        <ProtectedRoute roles={['whitelabel_agency']}>

          <DashboardLayout>

            <WhiteLabelDashboard />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* Super Admin: Agencies */}

      <Route path="/admin/agencies" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <AllAgenciesList />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      <Route path="/admin/agencies/registrations" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <AgencyRegistrations />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      <Route path="/admin/agencies/details" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <AgencyDetails />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      <Route path="/admin/agencies/actions" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <AgencyActions />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      <Route path="/admin/agencies/whitelabel" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <WhiteLabelAgenciesList />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      <Route path="/admin/agencies/whitelabel/:id" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <WhiteLabelAgencyDetails />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* Super Admin: Clients */}

      <Route path="/admin/clients" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <AllClientsList />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      <Route path="/admin/clients/details" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <ClientDetails />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      <Route path="/admin/clients/transfer" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <AssignTransferClients />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* Super Admin: Workspaces */}

      <Route path="/admin/workspaces" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <WorkspacesOverview />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* Super Admin: Estimates */}

      <Route path="/admin/estimates" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <Estimates />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* Super Admin: Create Campaign */}

      <Route path="/admin/create-campaign" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <CreateCampaign />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* Super Admin: Database */}

      <Route path="/admin/database-management" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <DatabaseManagement />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* Super Admin: Campaigns */}

      <Route path="/admin/campaigns" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <AllCampaignsList />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      <Route path="/admin/campaigns/approvals" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <CampaignApprovals />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      <Route path="/admin/campaigns/flagged" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <CampaignsFlagged />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* Super Admin: Billing - New consolidated page with tabs */}

      <Route path="/admin/billing" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <BillingSubscriptions />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* Keep old routes for backward compatibility */}

      <Route path="/admin/billing/agency-plans" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <AgencyPlans />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      <Route path="/admin/billing/client-plans" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <ClientPlans />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      <Route path="/admin/billing/invoices" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <InvoicesPayments />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      <Route path="/admin/billing/payment-gateways" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <PaymentGateways />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* Super Admin: Integrations */}

      <Route path="/admin/integrations" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <IntegrationsControl />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      

      <Route path="/admin/integrations/facebook" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <FacebookSettings />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      <Route path="/admin/integrations/google-ads" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <GoogleAdsSettings />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      <Route path="/admin/integrations/other" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <OtherPlatforms />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* Super Admin: Settings */}

      <Route path="/admin/settings" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <PlatformSettings />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      

      <Route path="/admin/settings/branding" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <BrandingWhiteLabel />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      <Route path="/admin/settings/email-templates" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <EmailTemplates />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      <Route path="/admin/settings/roles-permissions" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <RolesPermissions />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* Super Admin: Users */}

      <Route path="/admin/users" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <UserManagement />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      

      <Route path="/admin/users/admins" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <AdminsList />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      <Route path="/admin/users/roles" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <UsersRoles />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* Super Admin: Analytics */}

      <Route path="/admin/analytics" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <AnalyticsReports />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      

      <Route path="/admin/analytics/revenue" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <RevenueReports />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      <Route path="/admin/analytics/campaigns" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <CampaignPerformance />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      <Route path="/admin/analytics/growth" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <GrowthMetrics />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* Super Admin: System */}

      <Route path="/admin/audit-logs" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <AuditLogs />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      <Route path="/admin/system-notifications" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <SystemNotifications />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* Super Admin: Demo Requests */}

      <Route path="/admin/demo-requests" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <DemoRequests />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* Super Admin: Support */}

      <Route path="/admin/support" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <SupportRequests />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      

      {/* Keep old route for backward compatibility */}

      <Route path="/admin/support/requests" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <SupportRequests />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      <Route path="/admin/support/assign" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <AssignTickets />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* Super Admin: Security */}

      <Route path="/admin/security" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <SecurityCompliance />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      

      <Route path="/admin/security/gdpr" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <GDPRPrivacy />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      <Route path="/admin/security/2fa" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <TwoFactorAuth />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      <Route path="/admin/security/api-keys" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <APIKeysManagement />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* Client: Campaigns */}

      <Route path="/client/campaigns" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientAllCampaigns />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      <Route path="/client/campaigns/create" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientCreateCampaign />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      <Route path="/client/campaigns/drafts" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientDraftsScheduled />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      <Route path="/client/campaigns/route-demo" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientRouteBasedDemo />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      <Route path="/client/campaigns/new-camp-demo" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientNewCampDemo />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      <Route path="/client/campaigns/new" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientNewCampaignUX />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/client/campaigns/new-campaign-ux" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientNewCampaignUX />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/client/campaigns/edit/:campaignId" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientEditCampaign />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/client/history" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientVehicleHistory />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/client/crm" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientProximityMarketing />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* Client: Subscribers Management */}

      <Route path="/client/subscribers-management" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <SubscribersManagement />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* Client: Creatives */}

      <Route path="/client/creatives/media" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientMediaLibrary />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      <Route path="/client/creatives/templates" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientTemplatesPresets />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      <Route path="/client/creatives/text" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientTextAssets />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* Client: Audience */}

      <Route path="/client/audience/saved" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientSavedAudiences />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      <Route path="/client/audience/lookalike" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientLookalikeAudiences />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      <Route path="/client/audience/builder" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientCustomAudienceBuilder />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* Client: Budgets */}

      <Route path="/client/budgets/planner" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientBudgetPlanner />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      <Route path="/client/budgets/calendar" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientSchedulingCalendar />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* Client: Analytics */}

      <Route path="/client/analytics/performance" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientAnalyticsPerformance />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      <Route path="/client/analytics/conversions" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientAnalyticsConversions />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      <Route path="/client/analytics/roi" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientAnalyticsROIReports />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* Client: NeighborhoodLens */}

      <Route path="/client/neighborhood-lens" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientNeighborhoodLens />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* Client: Dataset Payment (standalone page, no dashboard layout) */}

      <Route path="/client/payment/dataset" element={

        <ProtectedRoute roles={['client']}>

          <DatasetPayment />

        </ProtectedRoute>

      } />



      {/* Client: Integrations */}

      <Route path="/client/integrations" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientIntegrations />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      <Route path="/client/integrations/facebook" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientFacebookManager />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      <Route path="/client/integrations/google-ads" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientGoogleAds />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      <Route path="/client/integrations/other" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientOtherPlatforms />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* Client: Ad Creatives */}

      <Route path="/client/ad-creatives" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientAdCreatives />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* Client: Audience & Targeting */}

      <Route path="/client/audience" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientAudienceTargeting />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* Client: Budgets & Scheduling */}

      <Route path="/client/budgets" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientBudgetsScheduling />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* Client: Analytics & Reports */}

      <Route path="/client/analytics" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientAnalyticsReports />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* Client: Billing & Plans */}

      <Route path="/client/billing" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientBillingPlans />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* Client: Vehicle Management (Enterprise/Agency) */}

      <Route path="/client/vehicles" element={

        <ProtectedRoute roles={['client', 'agency', 'enterprise']}>

          <DashboardLayout>

            <ClientVehicleManagement />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* Client: Settings */}

      <Route path="/client/settings" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientSettings />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* Client: Add-Ins Configuration */}

      <Route path="/client/addins" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientAddinsConfiguration />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* Client: Billing */}

      <Route path="/client/billing/subscription" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientCurrentSubscription />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      <Route path="/client/billing/history" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientPaymentHistory />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      <Route path="/client/billing/upgrade" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientUpgradePlan />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* Client: Notifications */}

      <Route path="/client/notifications" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientNotifications />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* Client: Support */}

      <Route path="/client/support" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientSupportCenter />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* Client: Settings */}

      <Route path="/client/settings/profile" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientProfileSettings />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/client/settings/security" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientSecurityLogin />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/client/settings/geotab" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientGeoTabSettings />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* Client: Add-ins */}

      <Route path="/client/addins/latest-insert-key-report" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientAddinLatestInsertKeyReport />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/client/addins/map-replay" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientAddinMapReplay />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/client/addins/surveillance-cameras" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientAddinSurveillanceCameras />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/client/addins/configration" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <ClientAddinsConfigration />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* Client: MCP Pages */}

      <Route path="/client/mcp/map" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <McpMap />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/client/mcp/fleet" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <McpFleet />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/client/mcp/audiences" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <McpAudiences />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/client/mcp/automations" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <McpAutomations />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/client/mcp/automations/new" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <McpAutomationFlow />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/client/mcp/connections" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <McpConnections />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/client/mcp/settings" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <McpSettings />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/client/mcp/billing" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <McpBilling />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/client/mcp/campaign" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <McpCampaign />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/client/mcp/build" element={

        <ProtectedRoute roles={['client']}>

          <DashboardLayout>

            <McpBuild />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* Agency Portal */}

      <Route path="/agency/dashboard" element={

        <ProtectedRoute roles={['agency']}>

          <DashboardLayout>

            <AgencyPortalDashboard />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* WhiteLabel Agency Portal */}

      <Route path="/whitelabel/dashboard" element={

        <ProtectedRoute roles={['whitelabel_agency']}>

          <DashboardLayout>

            <WhiteLabelDashboard />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/whitelabel/campaigns" element={

        <ProtectedRoute roles={['whitelabel_agency']}>

          <DashboardLayout>

            <WhiteLabelCampaigns />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/whitelabel/campaigns/create" element={

        <ProtectedRoute roles={['whitelabel_agency']}>

          <DashboardLayout>

            <WhiteLabelCreateCampaign />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/whitelabel/clients" element={

        <ProtectedRoute roles={['whitelabel_agency']}>

          <DashboardLayout>

            <WhiteLabelClients />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/whitelabel/clients/:clientId/dashboard" element={

        <ProtectedRoute roles={['whitelabel_agency']}>

          <DashboardLayout>

            <WhiteLabelClientDashboard />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/whitelabel/commissions" element={

        <ProtectedRoute roles={['whitelabel_agency']}>

          <DashboardLayout>

            <WhiteLabelCommissions />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/whitelabel/settings" element={

        <ProtectedRoute roles={['whitelabel_agency']}>

          <DashboardLayout>

            <WhiteLabelSettings />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/whitelabel/billing" element={

        <ProtectedRoute roles={['whitelabel_agency']}>

          <DashboardLayout>

            <WhiteLabelBilling />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/whitelabel/analytics" element={

        <ProtectedRoute roles={['whitelabel_agency']}>

          <DashboardLayout>

            <WhiteLabelAnalytics />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/whitelabel/ai-tools" element={

        <ProtectedRoute roles={['whitelabel_agency']}>

          <DashboardLayout>

            <WhiteLabelAITools />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/whitelabel/reports" element={

        <ProtectedRoute roles={['whitelabel_agency']}>

          <DashboardLayout>

            <WhiteLabelReports />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/whitelabel/locations" element={

        <ProtectedRoute roles={['whitelabel_agency']}>

          <DashboardLayout>

            <WhiteLabelLocations />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/whitelabel/integrations" element={

        <ProtectedRoute roles={['whitelabel_agency']}>

          <DashboardLayout>

            <WhiteLabelIntegrations />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/whitelabel/settings/pricing" element={

        <ProtectedRoute roles={['whitelabel_agency']}>

          <DashboardLayout>

            <WhiteLabelPricing />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/whitelabel/settings/roles" element={

        <ProtectedRoute roles={['whitelabel_agency']}>

          <DashboardLayout>

            <WhiteLabelRoles />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/whitelabel/settings/domain" element={

        <ProtectedRoute roles={['whitelabel_agency']}>

          <DashboardLayout>

            <WhiteLabelDomain />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/whitelabel/settings/neighborhood-lens" element={

        <ProtectedRoute roles={['whitelabel_agency']}>

          <DashboardLayout>

            <WhiteLabelNeighborhoodLens />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/whitelabel/settings/branding" element={

        <ProtectedRoute roles={['whitelabel_agency']}>

          <DashboardLayout>

            <WhiteLabelBranding />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/whitelabel/settings/business-profile" element={

        <ProtectedRoute roles={['whitelabel_agency']}>

          <DashboardLayout>

            <WhiteLabelBusinessProfile />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/whitelabel/support" element={

        <ProtectedRoute roles={['whitelabel_agency']}>

          <DashboardLayout>

            <WhiteLabelSupport />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* Agency: NeighborhoodLens */}

      <Route path="/agency/neighborhood-lens" element={

        <ProtectedRoute roles={['agency']}>

          <DashboardLayout>

            <NeighborhoodLens />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* Agency: Consolidated Pages with Tabs */}

      <Route path="/agency/workspaces" element={

        <ProtectedRoute roles={['agency']}>

          <DashboardLayout>

            <AgencyWorkspaces />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/agency/vehicles" element={

        <ProtectedRoute roles={['agency']}>

          <DashboardLayout>

            <ClientVehicleManagement />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/admin/vehicles-management" element={

        <ProtectedRoute roles={['superadmin']}>

          <DashboardLayout>

            <AdminVehicleManagement />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/agency/clients" element={

        <ProtectedRoute roles={['agency']}>

          <DashboardLayout>

            <AgencyClients />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/agency/campaigns" element={

        <ProtectedRoute roles={['agency']}>

          <DashboardLayout>

            <AgencyCampaigns />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/agency/new-campaign" element={

        <ProtectedRoute roles={['agency']}>

          <DashboardLayout>

            <AgencyNewCampaign />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/agency/campaigns/new-campaign-ux" element={

        <ProtectedRoute roles={['agency']}>

          <DashboardLayout>

            <ClientNewCampaignUX />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/agency/creatives" element={

        <ProtectedRoute roles={['agency']}>

          <DashboardLayout>

            <AgencyCreatives />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/agency/audience" element={

        <ProtectedRoute roles={['agency']}>

          <DashboardLayout>

            <AgencyAudience />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/agency/budgets" element={

        <ProtectedRoute roles={['agency']}>

          <DashboardLayout>

            <AgencyBudgets />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/agency/analytics" element={

        <ProtectedRoute roles={['agency']}>

          <DashboardLayout>

            <AgencyAnalytics />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/agency/team" element={

        <ProtectedRoute roles={['agency']}>

          <DashboardLayout>

            <AgencyTeam />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/agency/integrations" element={

        <ProtectedRoute roles={['agency']}>

          <DashboardLayout>

            <AgencyIntegrations />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/agency/billing" element={

        <ProtectedRoute roles={['agency']}>

          <DashboardLayout>

            <AgencyBilling />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/agency/settings" element={

        <ProtectedRoute roles={['agency']}>

          <DashboardLayout>

            <AgencySettings />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/agency/notifications" element={

        <ProtectedRoute roles={['agency']}>

          <DashboardLayout>

            <AgencyNotifications />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/agency/support" element={

        <ProtectedRoute roles={['agency']}>

          <DashboardLayout>

            <AgencySupport />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/agency/chat" element={

        <ProtectedRoute roles={['agency']}>

          <DashboardLayout>

            <AgencyChat />

          </DashboardLayout>

        </ProtectedRoute>

      } />

      <Route path="/agency/ai-tools" element={

        <ProtectedRoute roles={['agency']}>

          <DashboardLayout>

            <AgencyAITools />

          </DashboardLayout>

        </ProtectedRoute>

      } />



      {/* Catch-all route for /dashboard */}

      <Route path="/dashboard" element={

        isAuthenticated() && !currentUser ? (

          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>

            <div className="loader">Loading...</div>

          </div>

        ) : currentUser ? (

          <Navigate to={

            currentUser.role === 'superadmin' ? '/dashboard/superadmin' :

            currentUser.role === 'agency' ? '/dashboard/agency' :

            currentUser.role === 'client' ? '/dashboard/client' :

            currentUser.role === 'whitelabel_agency' ? '/dashboard/whitelabel' : '/login'

          } replace />

        ) : (

          <Navigate to="/login" replace />

        )

      } />



      {/* Main Page */}

      <Route path="/" element={<Navigate to="/login" replace />} />

      

      



      {/* 404 - Not Found */}

      <Route path="*" element={

        <div style={{

          display: 'flex',

          justifyContent: 'center',

          alignItems: 'center',

          height: '100vh',

          flexDirection: 'column',

          backgroundColor: '#f0f2f5',

          padding: '20px',

          textAlign: 'center'

        }}>

          <h1 style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>404 - Page Not Found</h1>

          <p style={{ fontSize: '1.2rem', marginBottom: '2rem' }}>The page you are looking for does not exist or you don't have permission to view it.</p>

          <a 

            href="/" 

            style={{

              padding: '10px 20px',

              backgroundColor: '#1890ff',

              color: 'white',

              borderRadius: '4px',

              textDecoration: 'none',

              transition: 'background-color 0.3s'

            }}

            onMouseOver={e => e.currentTarget.style.backgroundColor = '#40a9ff'}

            onMouseOut={e => e.currentTarget.style.backgroundColor = '#1890ff'}

          >

            Go to Home

          </a>

        </div>

      } />

    </Routes>

  );

};



// Main App component with providers

const App = () => {

  return (

    <ThemeProvider>

      <ThemedConfigProvider>

        <AuthProvider>

          <Router>

            <div className="App">

              <AppContent />

            </div>

          </Router>

        </AuthProvider>

      </ThemedConfigProvider>

    </ThemeProvider>

  );

};



export default App;

